import { useContext } from "react";
import AdminAuthContext from "@components/ContextProviders/AdminAuthContext";

function useAdminAuth() {
  return useContext(AdminAuthContext);
}

export default useAdminAuth;
